<template>
  <div class="order_goods_push_table">
    <vs-table stripe maxHeight="20" :data="list">
      <template slot="thead">
        <vs-th>
          编号
        </vs-th>
        <vs-th>
          商品序号gnum
        </vs-th>
        <vs-th>
          价格price
        </vs-th>
        <vs-th>
          商品数量qty
        </vs-th>

        <vs-th>
          企业商品名称itemName
        </vs-th>
        <vs-th>
          商品规格型号gmodel
        </vs-th>
        <vs-th>
          原产国country
        </vs-th>
        <vs-th>
          单位unit
        </vs-th>
        <vs-th>
          总价totalPrice
        </vs-th>
        <vs-th>
          币制currency
        </vs-th>
      </template>

      <template slot-scope="{data}">
        <vs-tr
          :key="indextr"
          v-for="(tr, indextr) in data"
        >
          <vs-td :data="tr.id">
            {{tr.id}}
          </vs-td>

          <vs-td :data="tr.gnum">
            {{tr.gnum}}
            <template slot="edit">
              <vs-input
                v-model="tr.gnum"
                class="inputx"
                placeholder="商品序号"
              />
            </template>
          </vs-td>

          <vs-td :data="tr.price">
            {{tr.price}}
            <template slot="edit">
              <vs-input
                v-model="tr.price"
                class="inputx"
                placeholder="price"
              />
            </template>
          </vs-td>

          <vs-td :data="tr.count">
            {{tr.count}}
            <template slot="edit">
              <vs-input
                v-model="tr.count"
                class="inputx"
                placeholder="商品数量"
              />
            </template>
          </vs-td>

          <vs-td :data="tr.itemName">
            {{tr.itemName}}
            <template slot="edit">
              <vs-input
                v-model="tr.itemName"
                class="inputx"
                placeholder="企业商品名称"
              />
            </template>
          </vs-td>

          <vs-td :data="tr.gmodel">
            {{tr.gmodel}}
            <template slot="edit">
              <vs-input
                v-model="tr.gmodel"
                class="inputx"
                placeholder="商品规格型号"
              />
            </template>
          </vs-td>

          <vs-td :data="tr.country">
            {{tr.country}}
            <template slot="edit">
              <vs-input
                v-model="tr.country"
                class="inputx"
                placeholder="原产国"
              />
            </template>
          </vs-td>

          <vs-td :data="tr.unit">
            {{tr.unit}}
            <template slot="edit">
              <vs-input
                v-model="tr.unit"
                class="inputx"
                placeholder="单位"
              />
            </template>
          </vs-td>

          <vs-td :data="tr.totalPrice">
            {{tr.totalPrice}}
            <template slot="edit">
              <vs-input
                v-model="tr.totalPrice"
                class="inputx"
                placeholder="总价"
              />
            </template>
          </vs-td>

          <vs-td :data="tr.currency">
            {{tr.currency}}
            <template slot="edit">
              <vs-input
                v-model="tr.currency"
                class="inputx"
                placeholder="币制"
              />
            </template>
          </vs-td>

        </vs-tr>
      </template>
    </vs-table>
  </div>
</template>

<script>
export default {
  name: 'theConfigGoodsTable',

  created() {

  },
  data() {
    return {
      list: []
    }
  },
  methods: {
    setGoodsData(pa) {
      this.list = pa;
    },
    getGoodsDataList() {
      return this.list;
    },
    cancelPrompt(){
      this.list = []
    }
  },
}
</script>

<style lang="scss">
.order_goods_push_table thead .vs-table-text{
  white-space: nowrap !important;
}
</style>
